import { render } from "./VerticalNavMenuItems.vue?vue&type=template&id=45a274fc"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
script.render = render

export default script